import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/product.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import(/* webpackChunkName: "about" */ '../views/technology.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  }
  ,
  {
    path: '/case',
    name: 'case',
    component: () => import(/* webpackChunkName: "about" */ '../views/case.vue')
  }
  ,
  {
    path: '/FAQ',
    name: 'faq',
    component: () => import(/* webpackChunkName: "about" */ '../views/faq.vue')
  }
  ,
  {
    path: '/demonstration',
    name: 'demonstration',
    component: () => import(/* webpackChunkName: "about" */ '../views/demonstration.vue')
  }
  
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
